import React from "react";
import Button from "@material-ui/core/Button";

const uploadBtn = props => {
  const centerDiv = {
    margin: "0 auto"
  };

  return (
    <div style={centerDiv}>
      <Button
        variant="contained"
        color="primary"
        onClick={props.onClick}
      >
        {props.children}
      </Button>
    </div>
  );
};

export default uploadBtn;
